// @ts-expect-error untyped module reference-resolvers
import { EMAIL } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { emailUrl } from 'automation-ui-references/routing/hubspotUrls';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <EmailName id="123" />
 * Renders as:
 *   My Email Name
 */
const EmailName = ({
  disabled = false,
  id,
  messageKey,
  href = emailUrl(id)
}) => {
  return /*#__PURE__*/_jsx(ReferenceName, {
    id: id,
    referenceObjectType: EMAIL,
    href: disabled ? null : href,
    messageKey: messageKey
  });
};
export default EmailName;